export function getPropertyPanelAdminAuditLogsOverview(data) {
    return [
        {
            title: undefined,
            attributions: [
                { type: "text", subtitle: "ID", value: data.id, isEditable: false },
                {
                    type: "date",
                    subtitle: "Event occurrence date and time",
                    value: data.requested,
                    isEditable: false,
                },
            ],
        },
        {
            title: undefined,
            attributions: [
                { type: "text", subtitle: "Subject", value: data.subject, isEditable: false },
                { type: "text", subtitle: "Domain", value: data.domain, isEditable: false },
                {
                    type: "text",
                    subtitle: "Action",
                    value: data.description ?? data.action,
                    isEditable: false,
                },
                {
                    type: "text",
                    subtitle: "Resource ID",
                    value: data.targetId,
                    isEditable: false,
                },
            ],
        },
        {
            title: undefined,
            attributions: [{ type: "project", subtitle: "Project", value: data.project, isEditable: false }],
        },
        {
            title: undefined,
            attributions: [
                { type: "text", subtitle: "Client IP", value: data.sourceIp, isEditable: false },
                { type: "text", subtitle: "User Agent", value: data.userAgent, isEditable: false },
            ],
        },
    ];
}
